import axios from '@/plugins/axios'

let http = axios(process.env.VUE_APP_ACCOUNT_URL);

class Account
{
	login(payload) {
		return http.post('/auth/login', payload);
	}

	obtener_usuario() {
		return http.get('/mi-cuenta');
	}

	obtener_avatar() {
        return http.get('/mi-cuenta/avatar',null,{
            responseType: 'arraybuffer'
        });
    }

    enviar_otp(payload) {
    	return http.post('/otp', payload);
    }

    validar_otp(payload) {
    	return http.post('/otp/validar', payload);
    }

    crear_contacto(payload) {
    	return http.post('/mi-cuenta/contacto', payload);
    }

    actualizar_contacto(payload) {
    	return http.put('/mi-cuenta/contacto', payload);
    }

    subir_avatar(payload) {
    	return http.post('/mi-cuenta/avatar',payload);
    }

    cambiar_password(payload) {
    	return http.put('/mi-cuenta',payload);
    }

    eliminar_contacto(id) {
        return http.delete('/mi-cuenta/contacto/'+id);
    }

    recuperar_password(payload) {
        return http.post('/auth/recovery', payload);
    }

    recuperar_password_confirm(payload) {
        return http.put('/auth/recovery', payload);
    }
}

export default new Account();